import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numbersOnly]'
})
export class NumbersOnlyDirective {

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.which || event.keyCode);
    const regex = /^[0-9]*$/;
    if (!regex.test(inputChar)) {
      event.preventDefault();
    }
  }
}